/**
 * Runtime Analysis Module
 * 
 * Provides runtime environment detection and analysis
 */

// Types
export type { 
  Environment, 
  RuntimeAnalysis, 
  RuntimeCapabilities, 
  RuntimeConfig,
  RuntimeManifest 
} from './types';

// Core classes - import first for local use
import { EnvironmentDetector, getEnvironmentDetector } from './EnvironmentDetector';
import { RuntimeAnalyzer, getRuntimeAnalyzer } from './RuntimeAnalyzer';

// Re-export for external use
export { 
  EnvironmentDetector,
  getEnvironmentDetector 
} from './EnvironmentDetector';

export { 
  RuntimeAnalyzer,
  getRuntimeAnalyzer 
} from './RuntimeAnalyzer';

// Create default manifest
const _manifest = getRuntimeAnalyzer().createManifest('FreshCards');

export function getRuntimeManifest() {
  return _manifest;
}

// Default export object - uses locally imported functions
const runtimeAnalysisExports = {
  getEnvironmentDetector,
  getRuntimeAnalyzer,
  getRuntimeManifest
};

export default runtimeAnalysisExports;